import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThreeDots = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.0352 5.00879C15.0352 6.25143 14.0278 7.25879 12.7852 7.25879C11.5425 7.25879 10.5352 6.25143 10.5352 5.00879C10.5352 3.76615 11.5425 2.75879 12.7852 2.75879C14.0278 2.75879 15.0352 3.76615 15.0352 5.00879ZM15.0352 12.8838C15.0352 14.1264 14.0278 15.1338 12.7852 15.1338C11.5425 15.1338 10.5352 14.1264 10.5352 12.8838C10.5352 11.6411 11.5425 10.6338 12.7852 10.6338C14.0278 10.6338 15.0352 11.6411 15.0352 12.8838ZM12.7852 23.0088C14.0278 23.0088 15.0352 22.0014 15.0352 20.7588C15.0352 19.5161 14.0278 18.5088 12.7852 18.5088C11.5425 18.5088 10.5352 19.5161 10.5352 20.7588C10.5352 22.0014 11.5425 23.0088 12.7852 23.0088Z"
	})
});
export default SvgThreeDots;
